import React, { useState } from "react";

interface IChipItem {
    displayText: string;
    hasError?: boolean;
}

const useFormChipInput = (validate: (value: string) => boolean, prevChipList?:IChipItem[]) => {
    const [ currentInputValue, setCurrentInputValue ] = useState<string>("");
    const [ chipList, setChipList ] = useState<IChipItem[]>(prevChipList??[]);
    const setInputValue = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCurrentInputValue(event.currentTarget.value);
    }

    const addItem = (displayText: string) => {
        const textList = chipList.map((chipItem: IChipItem) => chipItem.displayText);
        const itemIndexInList = textList.indexOf(displayText);
        if(itemIndexInList < 0){
            setChipList([...chipList, {
                displayText,
                hasError: !validate(displayText)
            }]);
        }
    }

    const removeItem = (index: number) => {
        setChipList([...chipList.filter((_, i) => i !== index )]);
    } 

    const clearValue = () => {
        setCurrentInputValue("");
    }

    const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if(["Tab", ",", "Enter", " "].includes(event.key)) {
            event.preventDefault();
            if(currentInputValue.length > 3){
                addItem(currentInputValue);
                clearValue();
            }
        }
    }

    const onPaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
        event.preventDefault();
        let itemsToAdd = [];
        let data = event.clipboardData.getData("text").split(/[\s,]+/);
        for(let itemString of data){
            if(itemString.length > 3) {
                itemsToAdd.push({
                    displayText: itemString, 
                    hasError: !validate(itemString)
                })
            }
        };
        setChipList([...chipList, ...itemsToAdd]);
    }

    const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        if(currentInputValue.length > 3){
            addItem(event.currentTarget.value);
            clearValue();
        }
    }

    return {
        currentInputValue,
        chipList,
        removeItem,
        onKeyDown,
        onPaste,
        onBlur,
        setInputValue,
        setChipList
    }

}

export default useFormChipInput;